export default __webpack_public_path__ + "static/media/ico-transaction.e3d54381.svg";